<template>
  <div class="home-category" :class="[deviceType]">
    <div class="category-header">
      <router-link to="/categories" class="category-title-link">
        <div class="category-title">Categories</div>
      </router-link>
    </div>
    <div class="category-list">
      <div class="category-section" v-for="(section, sectionIndex) in categories"
        :key="sectionIndex">
        <div class="section-title-wrapper">
          <div class="dot"></div>
          <span class="section-title">{{ section.title }}</span>
        </div>
        <div class="section-buttons">
          <router-link v-for="(item, itemIndex) in section.items" :key="itemIndex"
            :to="getCategoryPath(section.title, item.title)" tag="div"
            :class="getButtonClass(section.title, item.isViewAll)"
            :style="getButtonStyle(section.title, itemIndex)">
            <span class="button-text">{{ item.title }}</span>
            <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomeCategory',
  computed: {
    ...mapGetters([
      'deviceType',
      'gender',
      'style',
      'meaning'
    ]),
    categories () {
      const result = [];
      const createItems = (list) => list.slice(0, 3).map(i => ({ title: i }));

      if (this.gender && this.gender.length > 0) {
        result.push({
          title: 'Name by Gender',
          items: [...createItems(this.gender), { title: 'View All', isViewAll: true }]
        });
      }
      if (this.style && this.style.length > 0) {
        result.push({
          title: 'Name by Style',
          items: [...createItems(this.style), { title: 'View All', isViewAll: true }]
        });
      }
      if (this.meaning && this.meaning.length > 0) {
        result.push({
          title: 'Name by Meaning',
          items: [...createItems(this.meaning), { title: 'View All', isViewAll: true }]
        });
      }
      return result;
    }
  },
  methods: {
    getCategoryPath (sectionTitle, itemTitle = null) {
      let categoryType = '';
      switch (sectionTitle) {
        case 'Name by Gender':
          categoryType = 'gender';
          break;
        case 'Name by Style':
          categoryType = 'style';
          break;
        case 'Name by Meaning':
          categoryType = 'meaning';
          break;
        default:
          categoryType = 'general';
      }

      if (itemTitle && itemTitle !== 'View All') {
        const formattedValue = itemTitle.toLowerCase();
        return `/categories/${categoryType}/${formattedValue}`;
      } else {
        return `/categories/${categoryType}`;
      }
    },
    getButtonClass (sectionTitle, isViewAll) {
      if (isViewAll) return 'category-button view-all';
      if (sectionTitle === 'Name by Gender') return 'category-button colored';
      return 'category-button black';
    },
    getButtonStyle (sectionTitle, index) {
      if (sectionTitle === 'Name by Gender') {
        const colors = [
          'linear-gradient(180deg, #0088FF 0%, rgba(0, 136, 255, 0.2) 100%)',
          'linear-gradient(180deg, #E54CBA 0%, rgba(229, 76, 186, 0.2) 100%)',
          'linear-gradient(180deg, #C8AD17 0%, rgba(200, 173, 23, 0.2) 100%)'
        ];
        return { background: colors[index] };
      }
      return {};
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-category {
	padding: rem(40) rem(180);
	display: flex;
	flex-direction: column;
	gap: rem(24);
	background: #000;

	.category-header {
		.category-title-link {
			text-decoration: none;
			cursor: pointer;
		}
		.category-title {
			color: #ffffff;
			font-size: rem(24);
			line-height: rem(28);
			font-weight: 900;
		}
	}

	.category-list {
		display: flex;
		flex-direction: column;
		gap: rem(12);
		width: 100%;

		.category-section {
			background: rgba(255, 255, 255, 0.1);
			border-radius: rem(16);
			padding: rem(24);
			display: flex;
			align-items: center;
			gap: rem(24);
			box-sizing: border-box;

			.section-title-wrapper {
				display: flex;
				align-items: center;
				gap: rem(12);
				width: rem(168);
				flex-shrink: 0;

				.dot {
					width: rem(8);
					height: rem(8);
					background: #fff;
					border-radius: 50%;
				}

				.section-title {
					color: #ffffff;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 500;
				}
			}

			.section-buttons {
				display: flex;
				gap: rem(12);
				flex: 1;

				.category-button {
					border-radius: rem(12);
					padding: rem(12) rem(20);
					display: flex;
					align-items: center;
					justify-content: space-between;
					flex: 1;
					cursor: pointer;
					position: relative;
					overflow: hidden;

					.button-text {
						color: #ffffff;
						font-size: rem(16);
						font-weight: 900;
					}

					img {
						width: rem(6);
						height: rem(12);
					}

					&::before {
						content: '';
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						background: rgba(0, 0, 0, 0.3);
						opacity: 0;
						transition: opacity 0.3s ease;
					}

					&:hover::before {
						opacity: 1;
					}

					&.black {
						background: #000;

						&:hover {
							background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);

							&::before {
								opacity: 0; // Don't apply dimming on gradient hover
							}
						}
					}

					&.view-all {
						background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
						flex-grow: 0;
						flex-basis: rem(120);

						.button-text {
							font-size: rem(14);
							font-weight: 700;
						}
					}
				}
			}
		}
	}
}

.detect_deviece_mobile {
	.home-category {
		padding: rem(40) rem(16);

		.category-list {
			.category-section {
				flex-direction: column;
				align-items: flex-start;

				.section-buttons {
					width: 100%;
					flex-wrap: wrap;

					.category-button {
						flex-basis: 100%;
						&.view-all {
							flex-basis: 100%;
							margin-top: rem(12);
							justify-content: center;
							gap: rem(12);
						}
					}
				}
			}
		}
	}
}
</style> 